import { useState } from "react";

import type { EventSearchCondition } from "../../types/eventSearchCondition";
import type { GoodsSearchCondition } from "../../types/goodsSearchCondition";

type EventSearchConditionForState = EventSearchCondition & {
  type: "event";
};
type GoodsConditionForState = GoodsSearchCondition & {
  type: "goods";
};

type Default = null;
type Type = "event" | "goods";
type ConditionByType<T extends Type> = T extends "event"
  ? EventSearchConditionForState
  : GoodsConditionForState;
type Condition<T extends Type> = Default | ConditionByType<T>;

export const useSearchedCondition = <T extends Type>() => {
  const [searchedCondition, setSearchedCondition] =
    useState<Condition<T>>(null);
  const hasSearched = searchedCondition !== null;

  return [hasSearched, searchedCondition, setSearchedCondition] as const;
};
